"use client"

import CutEmeraldsHeader from "./cut-emeralds-header"
import CutEmeraldsGrid from "./cut-emeralds-grid"
import { useEffect } from "react"

export default function CutEmeraldsPage() {
  useEffect(()=>{
    window.scrollTo(0,0);
  },[])
  return (
    <div className="min-h-screen bg-neutral-50">
      <CutEmeraldsHeader />
      <CutEmeraldsGrid />
    </div>
  )
}
